import { createContext, useContext } from "react"
import type { CardSize } from "./types"

export const CardContext = createContext<{ size: CardSize }>({ size: "md" })

export const useCardContext = () => useContext(CardContext)
